module.exports = __webpack_public_path__ + "img/my_account.f6c60968.svg";